'use strict';

import angular from 'angular';
import {ArticuloComponent} from './articulo.component.js';
import {ArticuloListComponent} from './articulo-list/articulo-list.component';
import ArticuloService from './articulo.service';

export default angular.module('pizzutoAutopartesApp.articulo-component', [])
    .service('ArticuloService', ArticuloService)
    .component(ArticuloComponent.selector, ArticuloComponent)
    .component(ArticuloListComponent.selector, ArticuloListComponent)
    .name;


// WEBPACK FOOTER //
// ./client/components/articulo/index.js